import clsx from "clsx";
import { ProductInterface } from "./types";
import { useState } from "react";
interface QuizResultProductProps {
  product: ProductInterface;
}

const QuizResultProduct: React.FC<QuizResultProductProps> = ({ product }) => {
  const [addingToCart, setAddingToCart] = useState<boolean>(false);

  const addToCart = (el: HTMLElement, product: ProductInterface) => {
    setAddingToCart(true);

    const variantId = product.variants[0].id;
    if (!variantId) {
      console.error("No variant ID found");
      return;
    }

    (window as Window & { dataLayer?: unknown[] }).dataLayer?.push({
      event: "quizPurchase",
      ecommerce: { purchase: { products: [{ id: variantId }] } },
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then((r) => r.json())
      .then(() => {
        setAddingToCart(false);

        document.dispatchEvent(
          new CustomEvent("product:added", {
            detail: {
              variant: { id: variantId },
              quantity: 1,
            },
          }),
        );

        const cartIconButton = document.querySelector(
          "#header-cart-icon-button",
        ) as HTMLElement;

        if (cartIconButton) {
          cartIconButton.click();
        }
      })
      .catch(() => {
        setAddingToCart(false);
      });

    return false;
  };

  const additionalData = window.ALL_PRODUCTS.find((p) => p.id === product.id);

  return (
    <div className="quiz-result__state__product">
      <div className="product-card">
        <a href={product.url} className="product-card__featured">
          <div className="product-card__featured__image">
            <div className="product-card__image-container">
              <img
                src={product.images[0]}
                alt={product.title}
                title={product.title}
                className="product-card__image"
              />
            </div>
          </div>
        </a>

        <a href={product.url} className="product-card__details">
          <p className="product-card__details__title p1 bold">
            {product.title}
          </p>
          <p className="product-card__details__price visually-hidden p1">
            {product.price}
          </p>
        </a>
      </div>
      <h4 className="prod-subtitle">{additionalData?.quiz_description}</h4>{" "}
      <p className="desc">
        Made with: Passionflower, traditionally used in Western herbal medicine
        to relieve sleeplessness and Chamomile traditionally used in Western
        herbal medicine to calm the mind.
      </p>{" "}
      <div className="quiz-result__product-title hidden">{product.title}</div>
      <div className="prod-desc hidden">{product.description}</div>
      <div className="prod-price hidden">$47</div>{" "}
      <div className="prod-email-img hidden">
        <img
          src={product?.thumbnail}
          width="200"
          height="300"
          alt="HeadRest"
          loading="lazy"
        />
      </div>{" "}
      <div className="quiz-result__state_actions">
        <a href={product.url} className="btn btn--outlined">
          <span className="button__el">Learn more</span>
        </a>

        {product.available && (
          <a
            href={product.url}
            onClick={(e) => {
              e.preventDefault();
              addToCart(e.currentTarget as HTMLElement, product);
            }}
            className={clsx("btn btn--primary", { disabled: addingToCart })}
          >
            <span className="button__el">
              {addingToCart ? "Adding to cart..." : "Add to cart"}
            </span>
          </a>
        )}
      </div>
    </div>
  );
};

export default QuizResultProduct;
